module.exports = __webpack_public_path__ + "img/guide.7d095e32.png";